module.exports = __webpack_public_path__ + "static/media/Visualisation.969a86f3.mp3";